  async function updateCartDrawer() {
  const res = await fetch("/?section_id=quick-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
$(document).ready(function(){
setTimeout(function(){
      // let head = $("#tidio-chat iframe").contents().find("head");
      // console.log('ddwsd',head);
      // let css ='<style type="text/css">' +
      //     '.tidio-5hhiig{display:none !important}; ' +
      //     '</style>';
      // $(head).append(css);  
   let head2 = $(".trustpilot-widget[data-template-id='53aa8912dec7e10d38f59f36'] iframe").contents().find("head");
      console.log('fdsfkfnkds',head2);
      let css2 ='<style type="text/css">' +
          '#tp-widget-reviews-filter-label{display:none !important}; ' +
          '</style>';
      $(head2).append(css2);  
},10000)
 
});
$(function(){ 
  $('.product__color-chips .dynamic-variant-button').click(function(){
    // let len_val = $(this).val()
    console.log('length val') 
    setTimeout(function(){
      $('.product-swatches-color-block  button').each(function(){
            let clr = $(this).attr('data-val').trim()
        // let combination = len_val +' / '+ clr;      
              if($(this).hasClass('disabled')){
                console.log('disabled class')
                 // console.log('combination with colour',combination)
                 $(this).parent().parent().hide().removeClass('u_matched').addClass('u_unmatched')              
                }
        else{
                 $(this).parent().parent().show().removeClass('u_unmatched')
                           $(this).parent().parent().show().addClass('u_matched')
        }
          
  })
      $('.product-swatches-color-block.u_matched  button:first').trigger('click')
          },300)
})
      setTimeout(function(){
        console.log('ffee')
    $('.product__color-chips .dynamic-variant-button.selected').trigger('click')
      },1500)
   $('.select-wrapper .dynamic-variant-input').change(function(){
    let len_val = $(this).val()
    console.log('length val',len_val) 
    setTimeout(function(){
      $('.product-swatches-color-block  button').each(function(){
            let clr = $(this).attr('data-val').trim()
        let combination = len_val +' / '+ clr;      
              if($(this).hasClass('disabled')){
                console.log('disabled class')
                 console.log('combination with colour',combination)
                 $(this).parent().parent().hide().addClass('u_unmatched')
              
                }
        else{
                 $(this).parent().parent().show().removeClass('u_unmatched')
        }
          
  })
      $('.product-swatches-color-block  button:first').trigger('click')
          },300)
})
    $('.select-wrapper .dynamic-variant-input option:selected').trigger('change')
  fbt_product()
  function fbt_product(){
  let fbt_price=0;
  $('.u_fbt_pro_inp:checked').each(function(){
    fbt_price += parseInt($(this).attr('fbt-price').trim())
  })
  $('.u_fbt_price_val').text(Shopify.formatMoney(fbt_price))
  console.log('fbt price',fbt_price)
    if(fbt_price == 0){
      $('.u_fbt_inner').hide()
    }
    else{
            $('.u_fbt_inner').show()
    }
  }
  $('.u_fbt_pro_inp').change(function(){
        let pro_hnd =$(this).attr('pro-hnd').trim();
    if($(this).is(':checked')){
      $(this).closest('.u_fbt_pro_item').removeClass('unchecked_pro')
        $('.u_fbt_pro_bundle').each(function(){
      if($(this).attr('pro-hnd') == pro_hnd){
        $(this).show()
      }
    })
    }
    else{
      $(this).closest('.u_fbt_pro_item').addClass('unchecked_pro')
          $('.u_fbt_pro_bundle').each(function(){
      if($(this).attr('pro-hnd') == pro_hnd){
        $(this).hide()
      }
    })
    }
    fbt_product()
  })
  $('.u_fbt_var_select').change(function(){
    let fbt_var_price = $(this).find('option:selected').attr('var-price')
        let fbt_var_id = $(this).find('option:selected').attr('var-id')
            let fbt_var_img = $(this).find('option:selected').attr('var-image')
    console.log('price',fbt_var_price)
            let pro_hnd =$(this).find('option:selected').attr('pro-hnd').trim();
        $('.u_fbt_pro_bundle').each(function(){
      if($(this).attr('pro-hnd') == pro_hnd){
console.log('match')
        $(this).find('.u_fbt_bimage_size').attr('src',fbt_var_img)
      }
    })
    $(this).closest('.u_fbt_pro_item').find('.u_fbt_pro_price_size').text(Shopify.formatMoney(fbt_var_price))
     $(this).closest('.u_fbt_pro_item').find('.u_fbt_pro_inp').attr('fbt-price',fbt_var_price)
        $(this).closest('.u_fbt_pro_item').find('.u_fbt_pro_inp').attr('fbt-id',fbt_var_id)
    setTimeout(function(){
      fbt_product()
    },200)
  })
  $('.u_fbt_atc_size').click(function(){
     let ids=[];
      $('.u_fbt_pro_inp:checked').each(function(){
        let id =$(this).attr('fbt-id');
        let item={"id":id,"quantity":1 };
        ids.push(item);
      })
      console.log('array',ids);
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
        data:{items:ids},
        dataType: 'json',
         beforeSend: function() {
        // setting a timeout
           console.log('before enter');
                     $('.u_fbt_atc_text').attr('style','visibility:hidden')
           $('.u_btn__loading_wrap').show()
      },
        success: function(result){
        console.log('add to cart');
          $('.u_fbt_atc_text').show()
                                $('.u_btn__loading_wrap').hide()
          // updateCartDrawer(); 
          // $('.quick-cart__wrapper').addClass('active');
          location.href= '/cart'
     },
             error: function(err) {
console.log('error',err)
          let res_err = err.responseText;
      let f_err = JSON.parse(res_err)
      alertify.error(`${f_err.description}`);
      },
         complete: function() {
                      console.log('complete');
                     $('.u_fbt_atc_text').attr('style','visibility:visible')
                                $('.u_btn__loading_wrap').hide()
      }
    })
  })
  $('.product-form__cart-submit').click(function(){
    console.log('console.log','click')
    setTimeout(function(){
    },4000)
  })
    $(document).on('click','.purchase-confirmation-popup__close-button',function(){
          $('.u_popup_coverlay').hide()
    })
     $(document).on('click','.u_popup_coverlay,.u_purchase_cont_btn',function(){
          $('.u_popup_coverlay').hide()
       $('.animation--purchase-confirmation').removeClass('active')
              $('.animation--purchase-confirmation').removeClass('is-visible')
       $('.purchase-confirmation-popup__close-button').trigger('click')
    })

  setTimeout(function(){
    console.log('efff')
  $('.dynamic-variant-input option').each(function(){
    $(this).text($(this).text().replace(/\\/g, ''))
  })    
  },3000)
  $(document).on('click','.product__color-swatch,.dropdown-item ',function(){
       $('.dynamic-variant-input option').each(function(){
    $(this).text($(this).text().replace(/\\/g, ''))
  })   
  })
    $(document).on('change','.dynamic-variant-input',function(){
      console.log('change 788888888')
      setTimeout(function(){
   $('.dynamic-variant-input option').each(function(){
    $(this).text($(this).text().replace(/\\/g, ''))
  })
      },300)
  }) 
  $('.u_check_forgot_btn').click(function(){
    $('.u_check_pro_wrapper_login').hide()
      $('.u_check_pro_forgotwrapper').show()
  })
  
    $('.u_forgot_cancel').click(function(){
    $('.u_check_pro_wrapper_login').show()
      $('.u_check_pro_forgotwrapper').hide()
  })
  if($(window).width() < 768){
        $('.u_sticky_atc_block').show()
      }
      else{
        $('.u_sticky_atc_block').hide()
      }
      $('.u_sticky_atc_btn').click(function(){
        $('.product-form__cart-submit').trigger('click')
      })
       $(document).scroll(function(){
      let scroll = $(this).scrollTop()
      console.log('scroll',scroll)
      let sec_height = $('.u_product_form').height()
      console.log('sec height',sec_height)
      if(scroll > 1000){
         $('.u_sticky_atc_wrapper').show()
      }
      else{
                $('.u_sticky_atc_wrapper').hide()
      }
    })
  $('.u_atc_select').change(function(){

    let qty = $(this).find('option:selected').val().trim();
        console.log('help',qty)
    $('.u_product_qty').attr('value',qty)
  })
    $(document).on('click','.product-form__cart-submit',function(){
setTimeout(function(){
  console.log('append')
let size =$('.product__meta-recommendations-sidebar-items').length
  console.log('size',size)
  if(size >= 1){
    $('.u_purchase_may_size').show()
  $('.product__meta-recommendations-sidebar-items').clone().appendTo('.u_purchase_may_section')
    console.log('append after')
  }
},5000)
    })

 $('.u_sticky_minus').click(function(){
    let input =$(this).parent().find('.u_number');
    let count =parseInt(input.val()) -1;
    let counter = count <1 ?1:count;
    input.val(counter);
    input.attr('value',counter);
     $('.u_product_qty').attr('value',counter)
 })
   $('.u_sticky_plus').click(function(){
    let input =$(this).parent().find('.u_number');
 let count =parseInt(input.val()) +1;
    input.val(count);
     input.attr('value',count);
       $('.u_product_qty').attr('value',count)
 })
  $(document).on('click','.u_carticle_pro_atc_btn',function(){
      let v_id =$(this).attr('apro-id');
    console.log('v_id',v_id)
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
        data :{"id":v_id,
              "quantity":1
             },
        dataType: 'json',
         beforeSend: function() {
        // setting a timeout
           console.log('before enter');
                     $('.u_fbt_atc_text').attr('style','visibility:hidden')
           $('.u_btn__loading_wrap').show()
      },
        success: function(result){
        console.log('add to cart');
          $('.u_fbt_atc_text').show()
                                $('.u_btn__loading_wrap').hide()
          // updateCartDrawer(); 
          // $('.quick-cart__wrapper').addClass('active');
          location.href= '/cart'
     },
             error: function(err) {
console.log('error',err)
          let res_err = err.responseText;
      let f_err = JSON.parse(res_err)
      alertify.error(`${f_err.description}`);
      },
         complete: function() {
                      console.log('complete');
                     $('.u_fbt_atc_text').attr('style','visibility:visible')
                                $('.u_btn__loading_wrap').hide()
      }
    })
  })
  $(document).on('click','.header__menu-icon',function(){
    console.log('clickkkkkkkkkkk')  
    if($(this).hasClass('u_open_menu')){
          $('.modal-drawer-close').trigger('click')
        $('.header__menu-icon').removeClass('u_open_menu')
    }
    else{
      // $('.header__menu-icon').trigger('click')
        $(this).addClass('u_open_menu')
    }
  })
  $(document).on('click','.modal-drawer-close',function(){
    $('.header__menu-icon').removeClass('u_open_menu')
  })
   $(".u_navbar_fitem_text").hover(function(){
     $('.u_navbar_fitem_text').removeClass('u_active_menu')
  $(this).addClass('u_active_menu')
  })
        $("body").hover(function(e){
    console.log('body click  per')
           $('.u_navbar_fitem_text').removeClass('u_active_menu')
  });
//need to be add class parent class of whole predictive search form
  $('.u_menu_dk_list').hover(function(e){
    console.log('stop propagation per')
    e.stopPropagation();
  })
            $('.u_more_coll_menu_head').click(function(){
                // self clicking
                // animation
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').slideUp();
                    $(this).find('.u_coll_menu_icon i').addClass('fa-angle-down').removeClass('fa-angle-up');
                 }
                else{
                    $('.u_more_col_menu_third_block').removeClass('active').slideUp();
                $('.u_coll_menu_icon i').addClass('fa-angle-down').removeClass('fa-angle-up');
            $(this).next('.u_more_col_menu_third_block').addClass('active').slideDown();
            $(this).find('.u_coll_menu_icon i').addClass('fa-angle-up').removeClass('fa-angle-down');
                }
            })
  //product shipping accordian
    $('.u_pro_sh_accordian_head').click(function(){               
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').slideUp();
                    $(this).find('.u_pro_sh_icon i').addClass('fa-angle-down').removeClass('fa-angle-up');
                }
                else{
            $(this).next('.u_pro_sh_accordian_body').addClass('active').slideDown();
            $(this).find('.u_pro_sh_icon i').addClass('fa-angle-up').removeClass('fa-angle-down');
                }
            })
  if($(window).width()<990){
 let left_part = $('.u_page_left_side_block').detach()
  $('.u_append_left_side').append(left_part)
  }
  $(document).on('click','.u_purchase_check_btn,.cart__submit',function(e){
  if($('.u_attr_inp').is(':checked')){
    console.log('checked')
    $('.u_attr_error').empty()
  }
    else{
      console.log('not checked')
     
      $('.u_attr_error').text('Sorry - to proceed you must tick the box to confirm you agree to our Privacy Policy and Terms & Conditions.')
      e.preventDefault();
    }
  })
 })
 //discount banner
 $(function(){
   dis_banner()
 })

    function dis_banner(){
     let dis_price = $('.u_master_select').find('option:selected').attr('price-data')
      console.log('dis price' , dis_price )
      let m_dis = (dis_price* 10)/100;
      let final_dis = dis_price - m_dis
      console.log('final_dis',Shopify.formatMoney(final_dis))
      $('.u_discount_special_text').text(Shopify.formatMoney(final_dis))
    }
    $(function(){
     $(document).on('click','.dynamic-variant-button',function(){
       let var_title = $(this).attr('data-option-value').trim()
          $('.u_master_select option').each(function(){
            if($(this).attr('data-title')== var_title){
               let dis_price = $(this).attr('price-data')
      console.log('dis price' , dis_price )
      let m_dis = (dis_price* 10)/100;
      let final_dis = dis_price - m_dis
      console.log('final_dis',Shopify.formatMoney(final_dis))
      $('.u_discount_special_text').text(Shopify.formatMoney(final_dis))
            }
          })
     })
      $('.select-wrapper .dynamic-variant-input').change(function(){
        console.log('swdwd')
    let len_val = $(this).val()
    console.log('length val',len_val) 
         $('.u_master_select option').each(function(){
            if($(this).attr('data-title')== len_val){
               let dis_price = $(this).attr('price-data')
      console.log('dis price' , dis_price )
      let m_dis = (dis_price* 10)/100;
      let final_dis = dis_price - m_dis
      console.log('final_dis',Shopify.formatMoney(final_dis))
      $('.u_discount_special_text').text(Shopify.formatMoney(final_dis))
            }
          })
      })
          })